import moment from "moment-timezone";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../../../utils/api";
import { getErrorMessage } from "../../../../utils/helpers/errors";

const emptyClockExceptions = {
	cameEarly: 0,
	cameLate: 0,
	leftEarly: 0,
	leftLate: 0,
	notClocked: 0,
	notScheduled: 0,
	longBreak: 0,
	shortBreak: 0,
};
const mergeClockExceptionsWithDefaults = (clockExceptions) => {
	return Object.keys(emptyClockExceptions).reduce((result, key) => {
		result[key] = Number(clockExceptions?.[key]) || 0;
		return result;
	}, {});
};

const initialData = {
	nonApprovedTimesheets: {
		team: 0,
		weekly: 0,
	},
	missedPunches: 0,
	pendingRequests: {
		schedule: 0,
		clock: 0,
		availability: 0,
		pto: 0,
		timesheet: 0,
	},
	overtime: 0,
	mealViolation: {
		team: 0,
	},
	clockExceptions: emptyClockExceptions,
};

const mergeTaskListWithDefaults = (response) => {
	return {
		...initialData,
		...response,
		nonApprovedTimesheets: {
			...initialData.nonApprovedTimesheets,
			...response.nonApprovedTimesheets,
		},
		pendingRequests: {
			...initialData.pendingRequests,
			...response.pendingRequests,
		},
		mealViolation: {
			...initialData.mealViolation,
			...response.mealViolation,
		},
		clockExceptions: mergeClockExceptionsWithDefaults(response.clockExceptions),
	};
};

export const useTaskListApi = () => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(initialData);

	const { authGet } = useApi();

	const fetch = useCallback(
		async (controller) => {
			setLoading(true);
			try {
				const response = await authGet("/reports/task-list", {
					signal: controller?.signal,
					params: {
						from: moment().startOf("week").format("YYYY-MM-DD"),
						to: moment().endOf("week").format("YYYY-MM-DD"),
					},
				});
				if (response) {
					setData(mergeTaskListWithDefaults(response));
				}
			} catch (error) {
				if (!controller?.signal?.aborted) {
					getErrorMessage(error, t);
				}
			} finally {
				setLoading(false);
			}
		},
		[authGet, setLoading, t],
	);

	return {
		...data,
		loading,
		fetch,
	};
};
